import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class PdfFormTemplateSelectListComponent implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  billingAccountIds: string[];
  onChange: Function;

  private pdfFormTemplateRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $pdfFormTemplates, private $infiniteScroll) {
  }

  $onInit() {
    this.pdfFormTemplateRef = this.$pdfFormTemplates();
    this.loadLimit = 20;

    this.pdfFormTemplateRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.pdfFormTemplateRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.pdfFormTemplateRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit:  this.loadLimit,
      query:  this.queryString
    };
  }
}

angular
  .module('bringoz.admin.document-management')
  .component('pdfFormTemplateSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      billingAccountIds: '<?',
      onChange: '&'
    },
    template: require('./pdf-form-template-select-list.html').default,
    controller: PdfFormTemplateSelectListComponent
  });
